import {
    useCrearTipoImagen,
    useEditarTipoImagen,
  useListarTipoImagen,
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./campoFormulario";

export const TipoImagenForm = () => {
  return (
    <>
      <CustomForm
        camposFormulario={camposFormulario}
        querySubmit={useCrearTipoImagen}
      />
    </>
  );
};

export const TipoImagenEditar = () => {
  return (
    <CustomTable
      camposFilter={camposFilter}
      camposFormularioModal={camposFormulario}
      queryListar={useListarTipoImagen}
      queryEditar={useEditarTipoImagen}
      formatData={formatData}
      columns={columns}
      editable={true}

      camposAgregar={camposFormulario}
      queryCrear={useCrearTipoImagen}
    />
  );
};
